import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ITimeSpanExpressionBehavior } from "../../../../documaker/domain/format/objects";

export interface ITimeSpanExpressionBehaviorPropertyEditable {
  timeSpanExpressionBehavior(): IPropertyEditable<ITimeSpanExpressionBehavior>;
}

export function instanceOfITimeSpanExpressionBehaviorPropertyEditable(instance: any): instance is ITimeSpanExpressionBehaviorPropertyEditable {
  return instance
      && instance.timeSpanExpressionBehavior
      && instanceOfIPropertyEditable<ITimeSpanExpressionBehavior>(instance.timeSpanExpressionBehavior());
}
